import { takeEvery, put, all } from 'redux-saga/effects'
import { TRUCK_FEATURES_UPDATED, getTruckModules } from 'actions/truck'
import { getCtpInfoForVehicle } from 'actions/ctp'

export default function* watchTruckFeatureUpdate() {
  yield takeEvery(TRUCK_FEATURES_UPDATED, truckFeatureSideEffects)
}

function* truckFeatureSideEffects({ serialNumber }) {
  yield all([
    put(getTruckModules({ serialNumber })),
    put(getCtpInfoForVehicle({ serialNumber })),
  ])
}
